// WHOSE "MINE" (deals-door-1 T18, T19). Mine is decided on the server from the signed-in person's tracon_users id; the
// page only says when there is no person to be Mine for. From /auth/me's answer (lib/session fetchMe; null when it could
// not be read, never assumed personal): { personal, kind, sentence }. The shared login is not a person.
export const MINE_SHARED = 'Mine needs a personal sign-in.';
export const MINE_UNKNOWN = 'TRACON could not tell who is signed in, so Mine is off.';

export function mineFor(me) {
  const kind = me && me.kind ? me.kind : null;
  if (kind === 'personal') return { personal: true, kind, sentence: '' };
  return { personal: false, kind, sentence: kind === 'shared' ? MINE_SHARED : MINE_UNKNOWN };
}
